var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.term},[(_vm.type)?_c('span',{class:( _obj = {}, _obj[_vm.$style.operator] = true, _obj[_vm.$style[_vm.type]] = true, _obj )},[_vm._v(_vm._s(_vm.operator))]):_vm._e(),(_vm.hasError)?_c('span',{attrs:{"title":_vm.trace}},[_vm._v("ERROR")]):_c('span',[_vm._v(_vm._s(_vm.$i18n.format(_vm.value.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }